import React, { useState } from 'react';
import LateralMenuContent from '../LateralMenuContent';
import LivroForm from '../../../../components/Livro/LivroForm';
import { useLocation } from 'react-router';

export default function LivroFormMenu() {
    let livroProp = {};
    const location = useLocation();
    if (location.state) {
        livroProp = location.state.livro;
    }
    const [livro] = useState(livroProp);
    return (
        <LateralMenuContent child={LivroForm} livro={livro} />
    );
}